import { render } from "./addActive.vue?vue&type=template&id=8c96af50&scoped=true"
import script from "./addActive.vue?vue&type=script&lang=js"
export * from "./addActive.vue?vue&type=script&lang=js"

import "./addActive.vue?vue&type=style&index=0&id=8c96af50&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c96af50"],['__file',"src/views/active/addActive.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c96af50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c96af50', __exports__)) {
    console.log('reload')
    api.reload('8c96af50', __exports__)
  }
  
  module.hot.accept("./addActive.vue?vue&type=template&id=8c96af50&scoped=true", () => {
    console.log('re-render')
    api.rerender('8c96af50', render)
  })

}


export default __exports__